module.exports = __webpack_public_path__ + "static/media/preApprovedMoney.c31dfae0.svg";